import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	top: 60px;
	left: 60px;
	right: 60px;
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledRightContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 40px;
`;

export { StyledContainer, StyledRightContainer };
